const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const getClientEmails = queryVars => {
  const query = `query getClientEmails($clientId: ID) {
      getUsers(clientId: $clientId) {
        email
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}
